import React, {useEffect, useState} from "react";
import './TaxiForm.component.scss'
import Datepicker from 'react-datepicker'

interface DatePickerInputProps {
    onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined,
    placeholder?: string | undefined,
    value?: string | undefined,
    id?: string | undefined,
    onClick?: React.MouseEventHandler<HTMLInputElement>

}
const DatepickerInput = ({onChange, placeholder, value, id, onClick}: DatePickerInputProps) => (
    <label htmlFor={"date"} className={"calendar"}>
        <input
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            id={id}
            onClick={onClick}
            className={"input datepicker_input"}

    ></input>
    </label>
);
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}


export default function TaxiForm({showSearchBar}: {showSearchBar: boolean}) {
    const [date, setDate] = useState<Date | null>(new Date())
    const { width } = useWindowDimensions();
    return (
        <div className={"taxi-row"}>
            <label htmlFor={"from"} className={"place"}>
                <input type="text" placeholder={"from"} className={"input"}/>
            </label>
            <label htmlFor="to" className={"place"}>
                <input type="text" placeholder={"to"} className={"input"}/>
            </label>

            <Datepicker
                onChange={(date) => setDate(date)}
                selected={date}
                customInput={<DatepickerInput />}
                showTimeInput
                dateFormat={width > 750 ? "dd MMMM, yyyy H:mm a" : "dd MMMM, yyyy"}
                withPortal
                onChangeRaw={() => {}}
                minDate={new Date(Date.now())}

            />
            <label htmlFor="personCount" className={"person"}>
                <select name="personCount" id="personCount" className={"input"}>
                    {[...Array(4).keys()].map(
                        x => <option value={""+(x+1)}>{x+1}</option>
                    )}
                </select>
            </label>
            <label htmlFor="carry" className={"carry"}>
                <input type={"text"} className={"input"} placeholder={"carriage"}/>
            </label>
            {showSearchBar && <label htmlFor="search">
                <button type={"button"} className={"input search"}>search</button>
            </label>}

        </div>
    )
}